var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11C21.5 16.3762 16.8309 20.7904 11 20.7904C5.16908 20.7904 0.5 16.3762 0.5 11C0.5 5.62388 5.16908 1.20972 11 1.20972C16.8309 1.20972 21.5 5.62388 21.5 11Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.735 15.7097L10.05 11.0297L6.705 6.28972H8.115L10.83 10.1297L13.32 6.28972H14.745L11.475 11.0147L14.865 15.7097H13.425L10.695 11.9447L8.145 15.7097H6.735Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlack);
export default __webpack_public_path__ + "static/media/X_Black.4396841133906ea9c280b8b925573638.svg";
export { ForwardRef as ReactComponent };